<style lang="stylus">
    .topbar_middle
        width 100%
        height: 100%;
        margin 0 auto
        z-index 9
        display flex
        align-items center


        .topbar_logo
            margin-left 20px
            margin-right 10px
            width 21px
            height 21px
        .topbar_name
            height 14px
            line-height 16px
            letter-spacing 0px
            display inline-block
            vertical-align bottom
            font-size 16px
            font-weight bold
            color #6b6c6c

        .topbar_box
            float right

            .topbar_user
                float right
                padding-left 5px

                img
                    float left
                    width 25px
                    height 25px
                    border-radius 50%
                    margin-top 10px
                    margin-right 10px

                p
                    float left
                    margin-top 16px
                    margin-right 30px
                    font-size 14px
                    color #fff

    .blank
        width 180px
        height 1px
        background transparent
    .logBtn
        user-select none
    .logBtn:hover
        cursor pointer
    .buyAlert
        position fixed
        top 50%
        left 50%
        z-index 999
        box-shadow 0 0 6px #dedede
        transform: translateX(-50%) translateY(-50%);
        svg
            width 22px
            height 22px
            margin 8px 8px 0 0
    .downloadLink
        line-height 52px
        color #fff
        font-size 14px
    .downloadLink:active,.downloadLink:hover,.downloadLink:link,.downloadLink:visited
        color #fff
        text-decoration none
    #iframe1
        width 1200px
        height 800px
    @media screen and (max-width: 1500px)
        #iframe1
            width 1100px
            height 700px
    @media screen and (max-width: 1400px)
        #iframe1
            width 860px
            height 600px
</style>

<template>
    <div :style="{ height: '42px' }">
        <div class="topbar_middle">
            <iconSymbol class="topbar_logo" :name="'math-logo'" />
            <div class="topbar_name">EdrawMath</div>
            <!-- <img  src="@/public/img/mathIcon/edrawmath.png" alt=""> -->

            <!-- <div class="topbar_box">
                <div class="topbar_user">
                    <img :src="avatar" alt="">
                    <p v-text="nickName"></p> -->
            <!-- <p @click="iframeShow" class="logBtn"  v-if="!nolimit">购买</p> -->
            <!-- <iframe src="/static/buy/buy.html" frameborder="none"></iframe> -->
            <!-- <p @click="open()" v-if="log && !nolimit" class="logBtn">登录</p>
                    <p @click="logout()" v-if="!log && !nolimit" class="logBtn">退出</p> -->
            <!-- </div>

            </div> -->
        </div>
        <!-- <Col span="4">
        <a class="downloadLink" href="https://www.edrawsoft.cn/2download/edrawmath-cn.exe">下载桌面端</a>
        </Col> -->
        <!-- <div class="buyAlert" v-if="showIframe">
            <div style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:-10;"></div>
            <div style="background-color:#fff;text-align:right;line-height:30px">
                <iconSymbol name="math-close" @click.native="iframeClose"></iconSymbol>
            </div>
            <iframe id="iframe1" frameborder=”no” border=”0″ marginwidth=”0″ marginheight=”0″  src="./buy/buy.html" @load="asd" />
        </div> -->
        <!-- 暂时没vip，暂时注释
        <Modal v-model="nMem" width="300px" ok-text="确认" cancel-text="取消">
            <p v-text="alertText"></p>
        </Modal> -->
    </div>
</template>

<script lang="ts">
    declare var appConfig: any;
    import axios from "axios";
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";
    export default class homeHead extends Vue {
        showIframe = false;
        iframeState = false;
        log = true;
        userdata: any = {};
        link = "";
        token = "";
        ains = axios.create({
            baseURL: appConfig.api,
            timeout: 5000,
        });
        alertText = "非会员只能创建三个自定义公式";
        nMem = false;
        @Watch("userdata", { deep: true })
        onDataChanged(val, oldVal) {
            this.log = !this.log;
        }
        asd() {
            (<any>document.getElementById("iframe1")).contentWindow.buyapp.setUser(this.userdata, this.token);
        }
        iframeShow() {
            if (JSON.stringify(this.userdata) === "{}") {
                let ts = this as any;
                ts.$bus.$emit("openBox");
            } else {
                this.showIframe = true;
            }
        }
        iframeClose() {
            (<any>document.getElementById("iframe1")).contentWindow.buyapp.setUser({}, "");
            this.showIframe = false;
        }
        checkLog() {
            let ts = this;
            if (!!this.getToken("EDSession")) {
                var info = this.getToken("EDSession");
                this.initUser(info);
            } else if (!!this.getToken("EDCurrent")) {
                var info = this.getToken("EDCurrent");
                this.initUser(info);
            } else {
                this.open();
            }
        }
        getToken(name) {
            var cArr = document.cookie.split(";");
            var tok;
            var cName = name + "=";
            if (document.cookie) {
                cArr.forEach(function (t) {
                    var m = t.trim();
                    if (m.indexOf(cName) === 0) {
                        tok = m.slice(cName.length);
                    }
                });
            }
            return tok || undefined;
        }
        initUser(info) {
            let data = JSON.parse(info);
            var ts = this;
            ts.$store.state.token = data.token;
            ts.token = data.token;
            this.ains
                .get("/api/user/" + data.user_id + "?token=" + data.token)
                .then(function (response) {
                    ts.userdata = response.data.data;
                    ts.$store.state.islog = true;
                    ts.$store.state.userdata = response.data.data;
                    ts.checkVip();
                })
                .catch(function (error) {
                    ts.alertText = "登录失败，请稍后重试";
                    ts.nMem = true;
                });
        }
        checkVip() {
            var ts = this;
            this.ains
                .get("/api/user/" + ts.userdata.user_id + "/subscription/math?token=" + ts.token + "&id=" + ts.userdata.user_id)
                .then(function (response) {
                    ts.$store.state.isVip = response.data.status === "success" ? true : false;
                });
        }
        logout() {
            let ts = this as any;
            this.$store.state.isVip = false;
            this.$store.state.token = "";
            this.$store.state.userdata = "";
            this.$store.state.islog = false;
            ts.$bus.$emit("clearBoxList");
            var isThird = this.userdata.qq || this.userdata.weixin;
            if (isThird) {
                document.cookie = "EDUid=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
            }
            if (!!this.getToken("EDSession")) {
                document.cookie = "EDSession=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
            }
            if (!!this.getToken("EDCurrent")) {
                document.cookie = "EDCurrent=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
            }
            this.userdata = {};
        }
        open() {
            let ts = this as any;
            ts.$bus.$emit("openBox");
        }
        created() {
            if (!this.$store.state.ui.nolimitMath) this.checkLog();
        }
        get nolimit() {
            return this.$store.state.ui.nolimitMath;
        }
        get avatar() {
            if (this.userdata.avatar == undefined) {
                return "";
            }
            if (this.userdata.avatar !== "") {
                return "data:image/jpg;base64," + this.userdata.avatar;
            } else if (this.userdata.avatar_url !== "") {
                return encodeURI(this.userdata.avatar_url).replace(/([\(\)])/g, "\\$1");
            } else {
                return 'url("/src/icons/ava.png")';
            }
        }
        get nickName() {
            if (this.userdata.nick_name !== "") {
                return this.userdata.nick_name;
            }
        }
    }
</script>
